import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { FormService } from '../../organizations/features/booking/components/form/service';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-additional-service-option',
  imports: [MatTooltipModule, ReactiveFormsModule, CommonModule, MatIcon],
  templateUrl: './additional-service-option.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './additional-service-option.component.scss',
})
export class AdditionalServiceOptionComponent implements OnInit {

  @Input() option!: FormGroup;
  @Input() isEnforced: boolean = false;
  locale: string = "sv";
  formControl!: FormControl<boolean>;
  bookingService: FormService;
  showDescription: boolean = false;

  constructor(
    private translocoService: TranslocoService
  ) {
    this.bookingService = inject(FormService);
    this.translocoService.langChanges$.subscribe((lang) => {
      this.locale = lang;
    });
  }

  ngOnInit(): void {
    this.formControl = this.option.get('isSelected') as FormControl;
    if (this.isEnforced) {
      this.formControl.disable();
      this.formControl.setValue(true);
    } else {
      this.formControl.enable();
    }
  }
  
}
